import LookYouIcon from "./images/look-you.svg";
import CompletedIcon from "./images/completed.svg";
import Error from "./images/error.svg";
import Loop from "./images/loop.svg";

export const TOKEN_STATUS = {
    IN_PROGRESS: "IN_PROGRESS",
    FAILED: "FAILED",
    REJECTED: "REJECTED",
    SUCCESS: "SUCCESS",
    DEFAULT: "DEFAULT"
};

const TOKEN_FAIL_STATE = {
    title: "Sorry! We are facing issues in token transfer",
    ctaText: "",
    image: Error,
    altText: "failed"
};

export const DIY_TOKEN_STATES = {
    [TOKEN_STATUS.SUCCESS]: {
        title: "Token has been done!",
        ctaText: "VIEW DETAILS",
        image: CompletedIcon,
        altText: "completed"
    },
    [TOKEN_STATUS.FAILED]: {...TOKEN_FAIL_STATE},
    [TOKEN_STATUS.REJECTED]: {...TOKEN_FAIL_STATE},
    [TOKEN_STATUS.IN_PROGRESS]: {
        title: "Token is being transferred to your bank account",
        ctaText: "",
        image: Loop,
        altText: "in_progress"
    },
    [TOKEN_STATUS.DEFAULT]: {
        title: "Lock your offered price now!",
        ctaText: "GET TOKEN",
        image: LookYouIcon,
        altText: "Look"
    }
};

